import { render, staticRenderFns } from "./PerfilAnoLetivo.vue?vue&type=template&id=a3cdcc2a&scoped=true&"
import script from "./PerfilAnoLetivo.vue?vue&type=script&lang=js&"
export * from "./PerfilAnoLetivo.vue?vue&type=script&lang=js&"
import style0 from "./PerfilAnoLetivo.vue?vue&type=style&index=0&id=a3cdcc2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cdcc2a",
  null
  
)

export default component.exports